// ARSITEKTUR: Token disimpan di localStorage karena Kubernetes ingress menetapkan
// Access-Control-Allow-Origin: * sehingga httpOnly cookies tidak dapat digunakan
// (cookies memerlukan credentials:true yang tidak kompatibel dengan wildcard CORS).
// Mitigasi: CSP header ketat dan sanitasi input untuk mencegah XSS.
import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
const TOKEN_KEY = "rsh_token";

export const api = axios.create({ baseURL: `${BASE}/api` });

export const setToken = (t) => {
  if (t) localStorage.setItem(TOKEN_KEY, t);
  else localStorage.removeItem(TOKEN_KEY);
};
export const getToken = () => localStorage.getItem(TOKEN_KEY);

api.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export function apiError(e) {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  if (d?.msg) return d.msg;
  return e?.message || "Terjadi kesalahan. Coba lagi.";
}

export const rupiah = (n) =>
  "Rp " + Number(n || 0).toLocaleString("id-ID", { maximumFractionDigits: 0 });

export const tanggal = (s) => {
  if (!s) return "-";
  try {
    return new Date(s).toLocaleDateString("id-ID", {
      day: "numeric", month: "long", year: "numeric", timeZone: "Asia/Jakarta",
    });
  } catch { return s; }
};

export const waktu = (s) => {
  if (!s) return "-";
  try {
    return new Date(s).toLocaleString("id-ID", {
      day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit",
      timeZone: "Asia/Jakarta",
    });
  } catch { return s; }
};

export const FILE_BASE = BASE;
